import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart, BarChart, LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
} from 'echarts/components';
import { withInstall } from '../utils/index';
import './index.less';
import _Pie from './pie/index.vue';
import _Bar from './bar/index.vue';
import _Line from './line/index.vue';

use([
  CanvasRenderer,
  PieChart,
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
]);

export const TlbsPie = withInstall(_Pie);
export const TlbsBar = withInstall(_Bar);
export const TlbsLine = withInstall(_Line);
